export const getUserLastName = (fullname) => {
  return fullname.split(' ')[1];
};
